module.exports = __webpack_public_path__ + "7aebf3c0d048728504d4aec61b30925c.png";